module.exports = __webpack_public_path__ + "static/media/comment-account-outline.5eec1bd0.svg";